"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ CountUp; }
/* harmony export */ });
var __assign=undefined&&undefined.__assign||function(){return(__assign=Object.assign||function(t){for(var i,n=1,a=arguments.length;n<a;n++)for(var s in i=arguments[n])Object.prototype.hasOwnProperty.call(i,s)&&(t[s]=i[s]);return t}).apply(this,arguments)},CountUp=function(){function t(t,i,n){var a=this;this.endVal=i,this.options=n,this.version="2.2.0",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){a.startTime||(a.startTime=t);var i=t-a.startTime;a.remaining=a.duration-i,a.useEasing?a.countDown?a.frameVal=a.startVal-a.easingFn(i,0,a.startVal-a.endVal,a.duration):a.frameVal=a.easingFn(i,a.startVal,a.endVal-a.startVal,a.duration):a.countDown?a.frameVal=a.startVal-(a.startVal-a.endVal)*(i/a.duration):a.frameVal=a.startVal+(a.endVal-a.startVal)*(i/a.duration),a.countDown?a.frameVal=a.frameVal<a.endVal?a.endVal:a.frameVal:a.frameVal=a.frameVal>a.endVal?a.endVal:a.frameVal,a.frameVal=Number(a.frameVal.toFixed(a.options.decimalPlaces)),a.printValue(a.frameVal),i<a.duration?a.rAF=requestAnimationFrame(a.count):null!==a.finalEndVal?a.update(a.finalEndVal):a.callback&&a.callback()},this.formatNumber=function(t){var i,n,s,e,r=t<0?"-":"";i=Math.abs(t).toFixed(a.options.decimalPlaces);var o=(i+="").split(".");if(n=o[0],s=o.length>1?a.options.decimal+o[1]:"",a.options.useGrouping){e="";for(var l=0,h=n.length;l<h;++l)0!==l&&l%3==0&&(e=a.options.separator+e),e=n[h-l-1]+e;n=e}return a.options.numerals&&a.options.numerals.length&&(n=n.replace(/[0-9]/g,function(t){return a.options.numerals[+t]}),s=s.replace(/[0-9]/g,function(t){return a.options.numerals[+t]})),r+a.options.prefix+n+s+a.options.suffix},this.easeOutExpo=function(t,i,n,a){return n*(1-Math.pow(2,-10*t/a))*1024/1023+i},this.options=__assign(__assign({},this.defaults),n),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(i),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof t?document.getElementById(t):t,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined",void 0!==window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,t):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push(function(){return a.handleScroll(a)}),window.onscroll=function(){window.onScrollFns.forEach(function(t){return t()})},this.handleScroll(this)))}return t.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.offsetTop+t.el.offsetHeight;n<i&&n>window.scrollY&&t.paused?(t.paused=!1,setTimeout(function(){return t.start()},t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):window.scrollY>n&&!t.paused&&t.reset()}},t.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},t.prototype.start=function(t){this.error||(this.callback=t,this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},t.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},t.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},t.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,this.finalEndVal||this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},t.prototype.printValue=function(t){var i=this.formattingFn(t);"INPUT"===this.el.tagName?this.el.value=i:"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=i:this.el.innerHTML=i},t.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},t.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},t.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},t}();

/***/ }),

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ block_content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(8863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./components/photo.js
var photo = __webpack_require__(727);
// EXTERNAL MODULE: ./components/link.js + 1 modules
var components_link = __webpack_require__(8250);
;// CONCATENATED MODULE: ./components/block-serializers.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var blockSerializers = {
    types: {
        block: function(props) {
            var _node = props.node, markDefs = _node.markDefs, _style = _node.style, style = _style === void 0 ? "normal" : _style;
            // check if our block contains a button
            var hasButton = markDefs && markDefs.some(function(c) {
                return c._type === "link" && c.isButton === true;
            });
            // build our mock header styles
            if (style === "h1mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h1", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h2mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h2", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h3mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h4mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h4", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h5mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h5", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h6mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h6", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "large") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-lg-3-mobile", "md:text-lg-3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-large", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadSmall") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-small", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-large font-sansRegular", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "caption") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-caption", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            // go through our remaing, true header styles
            if (/^h\d/.test(style)) {
                return(/*#__PURE__*/ react.createElement(style, {
                    className: hasButton ? "has-btn" : null
                }, props.children));
            }
            // handle all other blocks with the default serializer
            return BlockContent_default().defaultSerializers.types.block(props);
        },
        photo: function(param) {
            var node = param.node;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                photo: node
            }));
        },
        horizontalRule: function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("hr", {});
        }
    },
    marks: {
        link: function(param) {
            var mark = param.mark, children = param.children;
            var title = children[0];
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                link: _objectSpread({}, mark, {
                    title: title
                })
            }));
        }
    }
};

;// CONCATENATED MODULE: ./components/block-content.js





var Content = function(param) {
    var blocks = param.blocks, className = param.className;
    if (!blocks) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        renderContainerOnSingleChild: true,
        className: classnames_default()("rc", className),
        blocks: blocks,
        serializers: blockSerializers
    }));
};
/* harmony default export */ var block_content = (Content);


/***/ }),

/***/ 3028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7627);
/* harmony import */ var _components_phrase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1995);
/* harmony import */ var _components_block_content__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1255);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7857);








var Grid = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var style = data.style, phrase = data.phrase, backgroundColor = data.backgroundColor, gridBlocks = data.gridBlocks;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openGridBlock = ref2[0], setOpenGridBlock = ref2[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid-section", "py-gutter", "relative", "z-20", "bg-".concat(backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.value), {
            "my-2 mx-2": style == "no-gutters"
        }),
        "data-theme": backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.title.toLowerCase(),
        children: [
            phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "text-center", "pt-10", "hidden", "sm:grid", "mb-5", "site-container"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            phrase: phrase,
                            typeStyle: "text-lg-1-mobile md:text-lg-1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "text-center", "pt-10", "sm:hidden", "site-container"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            phrase: phrase,
                            vertical: true,
                            dividerMaxWidth: "100px",
                            typeStyle: "text-lg-1-mobile md:text-lg-1"
                        })
                    })
                ]
            }),
            style == "default" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-2", "m-[10px]", "gap-[5px]"),
                "data-theme": backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.title.toLowerCase(),
                children: gridBlocks.map(function(block, idx) {
                    var ref, ref1;
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-2", "sm:col-span-1", "grid-block", "rounded-[3px]", "bg-".concat(block.backgroundColor.value)),
                        style: {
                            backgroundColor: (ref = block.backgroundColor) === null || ref === void 0 ? void 0 : ref.value
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("max-w-[501px]", "mx-auto"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2", "text-center", "p-10"),
                                    children: block.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("block-image"),
                                    children: block.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        photo: block.image,
                                        width: 1200,
                                        layout: "static",
                                        bgColor: (ref1 = block.backgroundColor) === null || ref1 === void 0 ? void 0 : ref1.title.toLowerCase()
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mx-auto", "text-large", "text-center", "font-sansRegular", "p-10"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_block_content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        blocks: block.body
                                    })
                                })
                            ]
                        })
                    }, idx));
                })
            }),
            style == "no-gutters" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex", "flex-wrap", "flex-col", "sm:flex-row", "my-[0px]", "gap-[0px]", "justify-center", "site-container", {
                    "py-0 md:py-[50px]": !phrase
                }),
                style: {
                    backgroundColor: backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.value
                },
                children: gridBlocks.map(function(block, idx) {
                    var ref, ref3;
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", "md:w-1/3", "grid-block", "py-10", "px-6", "bg-".concat(block === null || block === void 0 ? void 0 : (ref = block.backgroundColor) === null || ref === void 0 ? void 0 : ref.value), {
                            "sm:w-[40%]": gridBlocks.length == 2,
                            "md:w-[60%] pt-0": gridBlocks.length == 1
                        }),
                        "data-theme": (ref3 = block.backgroundColor) === null || ref3 === void 0 ? void 0 : ref3.title.toLowerCase(),
                        children: [
                            block.titlePlacement == "aboveImage" && block.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-3", "text-center", "mt-5", "pb-5", "md:min-h-[90px]"),
                                children: block.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex", "align-bottom"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("max-w-[100%]", "w-full", "mx-auto", "mt-auto", "flex", "flex-col", {
                                        "aspect-[5/4--disabled]": gridBlocks.length !== 1,
                                        "aspect-[3/2--disabled]": gridBlocks.length == 1
                                    }),
                                    children: block.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        photo: block.image,
                                        width: 1200,
                                        layout: "static",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-auto", "mb-2", "w-full", "h-full", "contain")
                                    })
                                })
                            }),
                            block.titlePlacement !== "aboveImage" && block.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-subheader", "uppercase", "text-center", "mt-5", "pb-3", "border-b", "font-sansBook"),
                                children: block.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("max-w-[100%]", "mx-auto", "text-large", "font-sansRegular", "text-center", "py-5", {
                                    "border-t": block.titlePlacement == "aboveImage"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("figure", "text-lg-3", "tabular-nums"),
                                        children: [
                                            block.figure && !block.animateFigure && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: block.figure
                                            }),
                                            block.figure && block.animateFigure && "object" !== "undefined" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                                start: "439000",
                                                end: "999999",
                                                decimal: ".",
                                                decimals: "0",
                                                separator: ",",
                                                prefix: "$",
                                                easing: "0.5, 1, 0.89, 1",
                                                duration: 10000
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mx-auto", "text-large", "text-center", "px-2", "mt-3", "font-sansRegular"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_block_content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            blocks: block.body
                                        })
                                    })
                                ]
                            })
                        ]
                    }, idx));
                })
            }),
            style == "inset" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "sm:grid-cols-20", "p-2", "md:p-0", "mx-auto", "gap-[5px]", "site-container"),
                children: gridBlocks.map(function(block, idx) {
                    var ref;
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "sm:col-span-9", "grid-block", {
                            "sm:col-start-2": idx % 2 == 0
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flip-card", "relative"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("front", "card-side", "bg-white", "pt-gutterInset", "px-gutterInset", "cursor-pointer"),
                                    onClick: function() {
                                        return setOpenGridBlock(idx);
                                    },
                                    "data-theme": "white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("max-w-[100%]", "mx-auto", "aspect-landscape--disabled", "relative"),
                                            children: block.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                photo: block.image,
                                                width: 1200,
                                                layout: "static"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("max-w-[60%]", "font-sansRegular", "tracking-[0.04em]", "mx-auto", "text-subheader-2", "uppercase", "text-center", "pt-10", "pb-[21px]"),
                                            children: block.title
                                        }),
                                        block.body && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[28px]", "h-[28px]", "absolute", "bottom-gutterInset", "right-gutterInset", "transition-transform", {
                                                "rotate-45": openGridBlock === idx
                                            }),
                                            onClick: function() {
                                                return setOpenGridBlock(idx);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                id: "open-circle-toggle-".concat(idx),
                                                name: "CircleToggle",
                                                viewBox: "0 0 26 26",
                                                color: "#000000",
                                                fill: "transparent"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("back", "p-3", "absolute", "top-0", "left-0", "w-full", "h-full", "z-20", "flex", "items-center", "justify-center", "card-side", "pointer-events-none", "transition-opacity", "text-large", "font-sansRegular", "tracking-[0]", "leading-[1.25]", "cursor-pointer", "bg-".concat(block.backgroundColor.value), {
                                        "opacity-0": openGridBlock !== idx,
                                        "opacity-100 pointer-events-auto": openGridBlock === idx
                                    }),
                                    onClick: function() {
                                        return setOpenGridBlock(false);
                                    },
                                    "data-theme": (ref = block.backgroundColor) === null || ref === void 0 ? void 0 : ref.title.toLowerCase(),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("content-wrap", "px-[8%]", "md:px-[15%]"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_block_content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                blocks: block.body
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[28px]", "h-[28px", "absolute", "bottom-gutterInset", "right-gutterInset", "transition-transform", {
                                                "rotate-45": openGridBlock === idx
                                            }),
                                            onClick: function() {
                                                return setOpenGridBlock(false);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                id: "close-circle-toggle-".concat(idx),
                                                name: "CircleToggle",
                                                viewBox: "0 0 26 26",
                                                color: "#000000",
                                                fill: "transparent"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, idx));
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Grid);


/***/ }),

/***/ 7857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(7294);
var countup_js = __webpack_require__(8273);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */

function useEventCallback(fn) {
  var ref = React.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
      decimals = props.decimals,
      duration = props.duration,
      easingFn = props.easingFn,
      end = props.end,
      formattingFn = props.formattingFn,
      numerals = props.numerals,
      prefix = props.prefix,
      separator = props.separator,
      start = props.start,
      suffix = props.suffix,
      useEasing = props.useEasing,
      enableScrollSpy = props.enableScrollSpy,
      scrollSpyDelay = props.scrollSpyDelay;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  startOnMount: true,
  enableReinitialize: true
};

var useCountUp = function useCountUp(props) {
  var _useMemo = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, DEFAULTS), props);
  }, [props]),
      ref = _useMemo.ref,
      startOnMount = _useMemo.startOnMount,
      enableReinitialize = _useMemo.enableReinitialize,
      delay = _useMemo.delay,
      onEnd = _useMemo.onEnd,
      onStart = _useMemo.onStart,
      onPauseResume = _useMemo.onPauseResume,
      onReset = _useMemo.onReset,
      onUpdate = _useMemo.onUpdate,
      instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);

  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;

    if (countUp && !recreate) {
      return countUp;
    }

    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };

    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }

    onStart === null || onStart === void 0 ? void 0 : onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 ? void 0 : onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    timerRef.current && clearTimeout(timerRef.current);
    getCountUp().reset();
    onReset === null || onReset === void 0 ? void 0 : onReset({
      pauseResume: pauseResume,
      start: restart,
      update: update
    });
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }

      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];

var CountUp = function CountUp(props) {
  var className = props.className,
      redraw = props.redraw,
      containerProps = props.containerProps,
      children = props.children,
      style = props.style,
      useCountUpProps = _objectWithoutProperties(props, _excluded);

  var containerRef = React__default["default"].useRef(null);
  var isInitializedRef = React__default["default"].useRef(false);

  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
    ref: containerRef,
    startOnMount: typeof children !== 'function' || props.delay === 0,
    // component manually restarts
    enableReinitialize: false
  })),
      start = _useCountUp.start,
      reset = _useCountUp.reset,
      updateCountUp = _useCountUp.update,
      pauseResume = _useCountUp.pauseResume,
      getCountUp = _useCountUp.getCountUp;

  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }

    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    } // unlike the hook, the CountUp component initializes on mount


    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props; // if props.redraw, call this effect on every props change

  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]); // if not props.redraw, call this effect only when certain props are changed

  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);

  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }

  return /*#__PURE__*/React__default["default"].createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), props.start ? getCountUp().formattingFn(props.start) : '');
};

exports.ZP = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

}]);